import { render, staticRenderFns } from "./Corporate.vue?vue&type=template&id=3f66499c&scoped=true&"
import script from "./Corporate.vue?vue&type=script&lang=js&"
export * from "./Corporate.vue?vue&type=script&lang=js&"
import style0 from "./Corporate.vue?vue&type=style&index=0&id=3f66499c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66499c",
  null
  
)

export default component.exports